import { debounce, throttle } from 'lodash';
import React, { useEffect, useCallback } from 'react';
import { observer, useLocalStore } from 'mobx-react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import Message from '@/component/Message';
import { Copy, Edit } from '@icon-park/react';
import { Tooltip } from '@byte-design/ui';
import Clipboard from 'clipboard';

interface Prop {
  id: string;
  config: any;
  containerRef: any;
}

function ErrorReport({ containerRef, id, config }: Prop) {
  const { t } = useTranslation();
  const state = useLocalStore(() => ({
    errorText: '',
    isShowErrprReport: false,
    reportBtnStyle: { display: 'none' },
  }));

  useEffect(() => {
    state.reportBtnStyle = { display: 'none' };
    const click = () => {
      state.reportBtnStyle = { display: 'none' };
      const text = (window as any).getSelection().toString();
      if (text.replace(/\n|\t/g, '')) {
        const node = (window as any).getSelection().getRangeAt(0);
        const {
          x, y, width, height,
        } = node.getBoundingClientRect();
        state.errorText = text;
        const style = { top: `${y - 50 < 0 ? y + height : y - 50}px`, left: `${x + width / 2 - 44}px` };
        state.reportBtnStyle = { display: 'flex', ...style };
      }
    };

    const scroll = throttle(() => {
      if (state.reportBtnStyle.display === 'flex') {
        state.reportBtnStyle = { display: 'none' };
      }
    }, 0);

    containerRef.current.addEventListener('mouseup', debounce(click));
    containerRef.current.addEventListener('scroll', scroll);
  }, [id]);

  const reportError = useCallback(() => {
    state.isShowErrprReport = true;
    state.reportBtnStyle = { display: 'none' };
  }, []);

  useEffect(() => {
    const clipboard = new Clipboard('#doc_copy', {
      // @ts-ignore
      text: () => state.errorText,
    });
    // @ts-ignore
    clipboard.on('success', () => {
      Message.success(t('copy_success'));
      state.reportBtnStyle = { display: 'none' };
    });
    return () => { clipboard.destroy(); };
  }, []);

  return (
    <>
      <div
        className={styles.reportError}
        style={state.reportBtnStyle}
      >
        {/* <div className={styles.item} onClick={reportError}>
          <Tooltip content={t('report_error')} placement="top">
            <Edit />
          </Tooltip>
        </div> */}
        <div className={styles.item} id="doc_copy">
          <Tooltip content={t('copy')} placement="top">
            <Copy />
          </Tooltip>
        </div>
      </div>
      {/* <ReportErrorModal
        isShow={state.isShowErrprReport}
        text={state.errorText}
        onCancel={() => { state.isShowErrprReport = false; }}
        onComfirm={async (text: string, obj: any) => {
          reportAthenaForm([
            { label: '标题', type: 14, content: '文档内容纠错' },
            { label: '标题错误内容', type: 2, content: `${state.errorText}--[文档地址：${window.location.href}]` },
            { label: '标题错误原因', type: 4, content: obj.reason },
            { label: '其他描述', type: 2, content: obj.desc },
          ], config);
          Message.success(t('thanks_report_error'));
          state.isShowErrprReport = false;
        }}
      /> */}
    </>
  );
}

export default React.memo(observer(ErrorReport));
